// eslint-disable-next-line import/prefer-default-export
export enum SearchIndex {
  PROJECTS = 'projects',
  FILES = 'files',
  PRONOUNCE = 'pronounce',
}
